import VaccinationCard from './VaccinationCard';

export default VaccinationCard;
